import React from 'react'
import './About.css'
const About = () => {
  return (
    <div className='container-about'>
  <h1>About Enimic</h1>
  
  <div className='about-card'>
    <h2>Our Vision</h2>
    <p>Enimic is a dynamic movie website aimed at providing you with an immersive cinematic experience. With Enimic,
       you can explore a vast collection of movies, read reviews, and stay up-to-date with the latest
       in the world of cinema. Whether you're a film enthusiast, a casual viewer, or someone looking for movie recommendations,
       Enimic is your go-to destination for everything movies.</p>
  </div>
  
  <div className='about-card'>
    <h2>Key Features</h2>
    <ul>
      <li><h3>Extensive Movie Database</h3></li>
      <li><h3>Read Reviews</h3></li>
      <li><h3>Personalized Recommendations</h3></li>
      <li><h3>User-friendly Interface</h3></li>
    </ul>
  </div>
  
  <div className='about-card'>
    <h2>Contact Us</h2>
    <p>We value your interaction and are here to assist you. If you have any inquiries, suggestions, or need support,
       feel free to get in touch. You can reach out to us via email at guptabhi40@gmail.com or by using the contact form
       on our website.</p>
    <button className="c-btn">Contact Us</button>
  </div>
  
  <div className='about-card'>
    <h2>Future Enhancements</h2>
    <p>We are committed to enhancing the Enimic experience and bringing you even more features and improvements. Your input
       matters, and we take your feedback seriously as we plan future updates. Stay tuned for exciting additions and enhancements
       that will elevate your movie exploration to new heights.</p>
  </div>
</div>

  
   
  );
};
export default About;

